import classes from "./FieldDataC.module.css";
import {  Route, Routes } from "react-router-dom";


import Dashboard from "../Dashboard/Dashboard";

import VoucherDetail from "../Voucher/VoucherDetails";
import VoucherNew from "../Voucher/VoucherNew";
import VoucherView from "../Voucher/VoucherView";
import ControlRoomForm from "../ControllRoom/ControlRoomForm";
import Ledger from "../Ledger/LedgerForm";
import Trail from "../TrailBalance/LedgerForm";
import ReportForm from "../Report/RequisitionNew";
import DebtorForm from "../Debtor Report/RequisitionNew";

const FieldDataS = (fieldProps) => {
  
  return (
    <div className={classes["Fields"]}>
      <Routes>
        <Route path="/dashboard" element={<Dashboard />} />

       
       
        <Route path="transaction/control" element={<ControlRoomForm />} />
        <Route path="transaction/ledger" element={<Ledger />} />
        <Route path="transaction/trail-balance" element={<Trail />} />
       
          <Route path="/net-due-report" element={<ReportForm />} />
          <Route path="/debtor-creditor-report" element={<DebtorForm />} />

       
        <Route path="/transaction/voucher-detail" element={<VoucherDetail />} />

        <Route path="/transaction/voucher-create" element={<VoucherNew />} />

        <Route path="/transaction/voucher-view/:id" element={<VoucherView />} />
      </Routes>
    </div>
  );
};

export default FieldDataS;
